import React from 'react';

const MAP = {
  approved: 'badge-success',
  active:   'badge-success',
  pending:  'badge-warning',
  rejected: 'badge-error',
  inactive: 'badge-error',
  info:     'badge-info',
  gold:     'badge-gold',
};

export default function StatusBadge({ status, label }) {
  const cls = MAP[status?.toLowerCase()] || 'badge-info';
  return (
    <span className={cls}>
      {label || status}
    </span>
  );
}
